module.exports = "pegasus/assets/blocks/header-8-theme6.png";